import { environment } from './environment';

export function getUri(resource: string, config: any) {
  const apiRoot: string = 'api/';
  const host = config.useProxy ? '/' : config[resource];
  const path =
    config.useCache || config.useProxy ? apiRoot + resource + '/' : '';
  return host + path;
}
// function to round a number to a given precision without padding
export function round(value: number, precision: number) {
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}
export function compareObjects(a: any, b: any) {
  return a && b ? a.id === b.id : a === b;
}
export function getGatewayUrl() {
  const allowedUrls = environment.gatewayUrls;
  const currentHost = window.location.host;
  return allowedUrls.find((url) => url.includes(currentHost)) ?? allowedUrls[0];
}
